import React, { Component } from "react";
import {
  FaClock,
  FaChartLine,
  FaUsers,
  FaCommentDots
} from "react-icons/fa";
import { GiRunningShoe } from "react-icons/gi";
import PageSection from "../../2/Controls/PageSection";
import { getProperty } from "../../../CommonFunctions";

export default class CampaignHeaderSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredIndex: null,
    };
  }

  handleMouseEnter = (index) => {
    this.setState({ hoveredIndex: index });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredIndex: null });
  };

  render() {
    const { campaign, getStatusBadge, totalStats, formatDateTime } = this.props;
    const { hoveredIndex } = this.state;

    const stats = [
      {
        label: "Last Run",
        value: formatDateTime(getProperty(campaign, 'LastRunDate')),
        icon: <FaClock style={{ color: "#2563eb" }} size={20} />,
        border: "#bfdbfe",
      },
      {
        label: "Total Runs",
        value: (getProperty(campaign, 'RunHistory') && getProperty(campaign, 'RunHistory').length) || 0,
        icon: <GiRunningShoe style={{ color: "#059669" }} size={20} />,
        border: "#a7f3d0",
      },
      {
        label: "Total Reach",
        value: getProperty(totalStats, 'customers'),
        icon: <FaUsers style={{ color: "#4f46e5" }} size={20} />,
        border: "#c7d2fe",
      },
    ];

    const channelData = [];
    if (getProperty(campaign, 'EnableWhatsapp')) channelData.push(`WhatsApp: ${getProperty(totalStats, 'whatsapp')}`);
    if (getProperty(campaign, 'EnableSMS')) channelData.push(`SMS: ${getProperty(totalStats, 'sms')}`);
    if (getProperty(campaign, 'EnableEmail')) channelData.push(`Email: ${getProperty(totalStats, 'email')}`);

    const gridStyles = {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "1.25rem",
    };

    // For responsive design, you can add a style tag or use CSS classes
    // Here's a simple approach using inline styles with a wrapper div

    return (
    
        
        <div style={gridStyles}>
          {stats.map((s, idx) => (
              <div
                        key={idx}
                        className={`info-box info-white`}
                       
                       
                      >
                        <div className="info-box-content">
                          <div className="info-box-gray-text"> {s.label}</div>
            
                          <div
                            className={!s.color ? "info-box-gray-number" : ""}
                            style={
                              s.color
                                ? { color: s.color, fontSize: "24px" }
                                : {}
                            }
                          >
                     {s.value && typeof s.value.toLocaleString === 'function' ? s.value.toLocaleString() : s.value}
                          </div>
                        </div>
                      </div>
          
          ))}



          {/* Single Channel Card */}
          {channelData.length > 0 && (
            <div
                        className={`info-box info-white`}
                       
                       
                      >
                        <div className="info-box-content">
                          <div className="info-box-gray-text">Channel</div>
            
                          <div
                            className={"info-box-gray-number"}
                          >
                      {channelData.join('   ')}
                          </div>
                        </div>
                      </div>
           
          )}
        </div>
    );
  }
}